import { createStore } from 'vuex';
import app from './modules/app'
import user from './modules/user'
import tagsView from './modules/tagsView'
import permission from './modules/permission'
import settings from './modules/settings'
import getters from './getters'
// 创建一个新的 store 实例
const store = createStore({
    state () {
      return {
        count: 0,
        stationStatus:false,
        stationMessage:[],
        total:0,
        headshow: true,
        noticeCount:0
      }
    },
    modules: {
      app,
      user,
      tagsView,
      permission,
      settings
    },
    getters,
    mutations: {
      increment (state) {
        state.count++;
      }
    }
  })
  export default store;